import { SHARED_REACT_QUERY_CONFIG } from '../../../constants/reactQuery.constant';
import {
  banks,
  creditCards,
  paymentMethods,
} from '../../../services/payments/payments.service';
import { getAdjustClause } from '../../../services/policy/policy.service';

export const EDIT_PAYMET_METHOD = 'editPaymentMethod';
export const EDIT_PAYMENT_METHOD_CONFIG = SHARED_REACT_QUERY_CONFIG;

export const EditPaymentMethodQuery = async ({ queryKey }: any) => {
  const params = queryKey[1];
  const request = await getAdjustClause(params.policy_id, params.vehicle_id);
  return request.data;
};

export const getBanksQuery = async () => {
  // const params = queryKey[1];
  const request = await banks();
  return request.data;
};

export const getCreditCardsQuery = async () => {
  const request = await creditCards();
  return request.data;
};

export const getPaymentMethodQuery = async ({ queryKey }: any) => {
  const params = queryKey[1];
  const request = await paymentMethods(params.policy_id);
  return request.data;
};

/* export const getValidateCbuNumberQuery = async({ queryKey}: any) => {
  const params = queryKey[1];
  const request = await validateCbuNumber(params.cbu);
  return request.data;
};

export const getValidateCreditCardNumberQuery = async({ queryKey}: any) => {
  const params = queryKey[1];
  const requst = await validateCreditCardNumber(params.creditCardNumber);
  return requst.data;
}; */
